var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4C1 2.34315 2.34315 1 4 1H6C7.65685 1 9 2.34315 9 4V6C9 7.65685 7.65685 9 6 9H4C2.34315 9 1 7.65685 1 6V4ZM4 3C3.44772 3 3 3.44772 3 4V6C3 6.55228 3.44772 7 4 7H6C6.55228 7 7 6.55228 7 6V4C7 3.44772 6.55228 3 6 3H4ZM11 4C11 2.34315 12.3431 1 14 1H16C17.6569 1 19 2.34315 19 4V6C19 7.65685 17.6569 9 16 9H14C12.3431 9 11 7.65685 11 6V4ZM14 3C13.4477 3 13 3.44772 13 4V6C13 6.55228 13.4477 7 14 7H16C16.5523 7 17 6.55228 17 6V4C17 3.44772 16.5523 3 16 3H14ZM1 14C1 12.3431 2.34315 11 4 11H6C7.65685 11 9 12.3431 9 14V16C9 17.6569 7.65685 19 6 19H4C2.34315 19 1 17.6569 1 16V14ZM4 13C3.44772 13 3 13.4477 3 14V16C3 16.5523 3.44772 17 4 17H6C6.55228 17 7 16.5523 7 16V14C7 13.4477 6.55228 13 6 13H4ZM11 14C11 12.3431 12.3431 11 14 11H16C17.6569 11 19 12.3431 19 14V16C19 17.6569 17.6569 19 16 19H14C12.3431 19 11 17.6569 11 16V14ZM14 13C13.4477 13 13 13.4477 13 14V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V14C17 13.4477 16.5523 13 16 13H14Z",
    fill: "#0A0046",
    stroke: "#DFE2E9",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardicon);
export default __webpack_public_path__ + "static/media/Dashboard icon.c18dfb503fd82dfe9d194f40442139f2.svg";
export { ForwardRef as ReactComponent };